import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Label } from 'reactstrap';
import {
  FormGroup,
  Field,
  Radio,
  RadioGroup
} from '@availity/form';
import { SelectField } from '@availity/select';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class PersonalInfoHousingHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToHousingPreference: false,
      redirectToTransportation: false,
      redirectToLandingPage: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    if (housingstore.getSupportiveHousingRouteStatus('/housingpreference') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/personalhousinghist') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/personalhousinghist') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/personalhousinghist', 'active');
    }
  }

  componentDidMount() {
    window.onpopstate = () => {
      this.props.navigate(1); 
    }
  }

  setPetOption = value => {
    housingstore.setPetOption(value);
  }

  setServiceAnimalOption = value => {
    housingstore.setServiceAnimalOption(value);
  }

  setSmokeOption = value => {
    housingstore.setSmokeOption(value);
  }

  setMarijuanaOption = value => {
    housingstore.setMarijuanaOption(value);
  }

  setDischargeOption = value => {
    housingstore.setDischargeOption(value);
  }

  setArrestedRadio = value => {
    housingstore.setArrestedRadio(value);
  }

  setCrimeOption = value => {
    housingstore.setCrimeOption(value);
  }

  setConvictedOption = value => {
    housingstore.setConvictedOption(value);
  }

  setRentalOption = value => {
    housingstore.setRentalOption(value);
  }

  setSubsidizedHousingOption = value => {
    housingstore.setSubsidizedHousingOption(value);
  }

  setPastDueOption = value => {
    housingstore.setPastDueOption(value);
  }

  setEvictedRentalOption = value => {
    housingstore.setEvictedRentalOption(value);
  }

  setPersonalInformation = event => {
    const { value, name } = event.target;
    housingstore.setPersonalInfo(name, value);
  }

  setwheelChairRadio = value => {
    housingstore.setwheelChairRadio(value);
  }

  setLivingWithClientRadio = value => {
    housingstore.setlivingWithClientRadio(value);
  }

  setManualElectric = value => {
    housingstore.setManualElectric(value);
  }
  
  goBack = () => {
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingstore.setSupportiveHousingRouteStatus('/housingpreference', 'active');
    housingstore.setSupportiveHousingRouteStatus('/personalhousinghist', 'inactive');
    this.setState({redirectToHousingPreference: true});
  }

  submit = (pendingRoute = '/transportationinformation') => {
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingstore.setSupportiveHousingRouteStatus('/personalhousinghist', 'completed');
    if (pendingRoute === '/transportationinformation') {
      this.setState({redirectToTransportation: true});
      return;
    }
    this.props.navigate(pendingRoute);
  }


  render() {

    const { redirectToHousingPreference, redirectToTransportation, redirectToLandingPage } = this.state;

    const { 
      personalInformationObj,
      supportiveHousingPagesAHAH,
      supportiveHousingPagesNoAHAH,
      memberInfo
    } = housingstore;

    const {
      wheelChairRadio,
      wheelWidth,
      manualElectric,
      petRadio,
      serviceAnimalRadio,
      smokeRadio,
      marijuanaRadio,
      dischargeRadio,
      arrestedRadio,
      crimeRadio,
      convictedRadio,
      livingWithClientRadio,
      famPartFriend,
      aidField,
      housingPreference,
      rentalRadio,
      subsidizedHousingRadio,
      pastDueRadio,
      evictedRentalRadio,
      evictedDatesField
    } = personalInformationObj

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if(redirectToHousingPreference) {
      return <Navigate to="/housingpreference" />
    }

    if(redirectToTransportation) {
      return <Navigate to="/transportationinformation" />
    }

    if(redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm 
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              wheelChairRadioOpt: wheelChairRadio,
              wheelchairWidth: wheelWidth,
              wheelchairManual: manualElectric,
              petRadioOption: petRadio,
              serviceAnimalRadioOpt: serviceAnimalRadio,
              smokeRadioOption: smokeRadio,
              marijuanaRadioOption: marijuanaRadio,
              dischargeRadioOption: dischargeRadio,
              arrestedRadioOption: arrestedRadio,
              crimeRadioOption: crimeRadio,
              convictedRadioOption: convictedRadio,
              livingWithClientRadioOption: livingWithClientRadio,
              famPartFriendField: famPartFriend,
              aidFieldOption: aidField,
              housingPreferenceField: housingPreference,
              rentalRadioOption: rentalRadio,
              subsidizedHousingRadioOption: subsidizedHousingRadio,
              pastDueRadioOption: pastDueRadio,
              evictedRentalRadioOption: evictedRentalRadio,
              evictedDatesFieldOption: evictedDatesField,
            }}
            onSubmit={this.submit}
            validationSchema={yup.object().shape({
              wheelchairWidth: wheelChairRadio === 'Yes' ? yup.string()
              .matches(/^\d+[0-9a-zA-Z. \'\-]*$/, 'Please only enter alpa-numeric, and special characters in this field (ex. 10 in., 20 cm)')
              .required('Please enter the wheel chair width') : yup.string().optional()
            })}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
              Housing Assessment
            </h2>
            <em>
              <small className="label-font">
                {`Please fill out to the best of your ability. Information in this section assesses the individual’s
                housing preferences, needs and assets. This information does not impact eligibility.`}
              </small>
            </em>
            <em>
              <small className="label-font">
                Identify individual traits that support the client's ability to obtain and maintain housing.
              </small>
            </em>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Personal information related to housing placement
            </h5>

            <div className="spacer" />

            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client use a wheelchair?
              </p>
              <RadioGroup value={wheelChairRadio} inline name="wheelChairRadioOpt" onChange={this.setwheelChairRadio}>
                <Radio className="label-font-round" name='wheelChairRadioOpt' label="Yes" value="Yes" />
                <Radio className="label-font-round" name='wheelChairRadioOpt' label="No" value="No" />
              </RadioGroup>
            </div>

            <p className="label-font">
              If yes, please list:
            </p>
            <Row className="mt-5 mb-5">
              {
                wheelChairRadio !== 'Yes' ?
                <div className="disableWidthManual d-flex">
                  <Col>
                    <FormGroup className="label-font" for='disabledField'>
                      <Field 
                        type="text"
                        label="Width (inches):"
                        name="disabledField"
                        className='straighten-borders'
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="label-font" for="disabledField">
                      <Field
                        type="text"
                        label="Manual or Electric:"
                        name="disabledField"
                        className='straighten-borders'
                        disabled
                      />
                    </FormGroup>
                  </Col>
                </div>
                :
                <>
                  <Col sm="2">
                    <FormGroup className="label-font" for="wheelchairWidth">
                      <Field 
                        type="text"
                        id="wheelchairWidth"
                        name="wheelchairWidth"
                        label="Width (Inches):"
                        className='straighten-borders'
                        onChange={this.setPersonalInformation}
                        value={wheelWidth}
                        maxLength={10}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="2">
                    <FormGroup className="label-font" for="wheelchairManual">
                      <SelectField
                        id="wheelchairManual"
                        name="wheelchairManual"
                        className='straighten-borders'
                        label="Manual or Electric:"
                        value={manualElectric}
                        onChange={this.setManualElectric}
                        placeholder="Select"
                        options={
                          [
                            {
                              value: 'Manual',
                              label: 'Manual'
                            },
                            {
                              value: 'Electric',
                              label: 'Electric'
                            }
                          ]
                        }
                      />
                    </FormGroup>
                  </Col>
                </>
              }
            </Row>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client have a pet?
              </p>
              <RadioGroup inline value={petRadio} name="petRadioOption" onChange={this.setPetOption}>
                <Radio className="label-font-round" name="petRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="petRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client have a service animal?
              </p>
              <RadioGroup inline value={serviceAnimalRadio} name="serviceAnimalRadioOpt" onChange={this.setServiceAnimalOption}>
                <Radio className="label-font-round" name="serviceAnimalRadioOpt" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="serviceAnimalRadioOpt" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client smoke?
              </p>
              <RadioGroup inline value={smokeRadio} name="smokeRadioOption" onChange={this.setSmokeOption}>
                <Radio className="label-font-round" name="smokeRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="smokeRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client use medical marijuana?
              </p>
              <RadioGroup inline value={marijuanaRadio} name="marijuanaRadioOption" onChange={this.setMarijuanaOption}>
                <Radio className="label-font-round" name="marijuanaRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="marijuanaRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Has the client served in the U.S. military with a qualified discharge?
              </p>
              <RadioGroup inline value={dischargeRadio} name="dischargeRadioOption" onChange={this.setDischargeOption}>
                <Radio className="label-font-round" name="dischargeRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="dischargeRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Has the client ever been arrested?
              </p>
              <RadioGroup inline value={arrestedRadio} name="arrestedRadioOption" onChange={this.setArrestedRadio}>
                <Radio className="label-font-round" name="arrestedRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="arrestedRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <em className="label-font mr-5">
                If yes, was the client charged and convicted of a crime?
              </em>
              <RadioGroup inline value={crimeRadio} name="crimeRadioOption" onChange={this.setCrimeOption}>
                <Radio className="label-font-round" name="crimeRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="crimeRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <em className="label-font mr-5">
                Is the client a registered sex offender or been convicted of manufacturing methamphetamines?
              </em>
              <RadioGroup inline value={convictedRadio} className="mb-0" name="convictedRadioOption" onChange={this.setConvictedOption}>
                <Radio className="label-font-round" name="convictedRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="convictedRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <em className="label-font mr-5">
              (If yes, no federal subsidies allowable)
            </em>
            <div className="d-flex mt-5">
              <p className="label-font mr-5">
                Will anyone else be living with the client?
              </p>
              <RadioGroup inline value={livingWithClientRadio} name="livingWithClientRadioOption" onChange={this.setLivingWithClientRadio}>
                <Radio className="label-font-round" name="livingWithClientRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="livingWithClientRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <em className="label-font mr-5">
              If yes, list relationship, name and contact information:
            </em>
            <Row className="mt-5 mb-5">
              {
                livingWithClientRadio !== 'Yes' ?
                <div className="disableFamilyAid d-flex">
                  <Col sm="6">
                    <FormGroup className="label-font" for="famPartFriendDisabled">
                      <Field
                        type="text"
                        name="famPartFriendDisabled"
                        label="Family/partner/friend"
                        className="straighten-borders"
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup className="label-font" for="aidDisabled">
                      <Field
                        type="text"
                        name="aidDisabled"
                        label="Live-in aid"
                        className="straighten-borders"
                        disabled
                      />
                    </FormGroup>
                  </Col>
                </div>
                :
                <>
                  <Col sm="6">
                    <FormGroup className="label-font" for="famPartFriendField">
                      <Field
                        type="text"
                        id="famPartFriendField"
                        name="famPartFriendField"
                        label="Family/partner/friend"
                        className='straighten-borders'
                        onChange={this.setPersonalInformation}
                        value={famPartFriend}
                        maxLength={200}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup className="label-font" for="aidField">
                      <Field
                        type="text"
                        id="aidField"
                        name="aidFieldOption"
                        label="Live-in aid"
                        className='straighten-borders'
                        onChange={this.setPersonalInformation}
                        value={aidField}
                        maxLength={200}
                      />
                    </FormGroup>
                  </Col>
                </>
              }
            </Row>
            <Row>
              <Col sm="6">
                <Label className="label-font" htmlFor="housingPreferenceField">
                  Please describe other relevant personal information related to housing placement:
                </Label>
                <Field
                  type="textarea"
                  id="housingPreferenceField"
                  name="housingPreferenceField"
                  className={'textAreaHeightDetails straighten-borders form-control form-group'}
                  onChange={this.setPersonalInformation}
                  value={housingPreference}
                  row="3"
                  col="200"
                  maxLength={300}
                />
                <p className="small text-right mb-0 label-font">300 Character max</p>
              </Col>
            </Row>
            <hr className="mtb-32" />
            <h2 className="poppinsH2">
              Housing History
            </h2>
            <div className="d-flex mt-5">
              <p className="label-font mr-5">
                Does the client have any rental history?
              </p>
              <RadioGroup inline value={rentalRadio} name="rentalRadioOption" onChange={this.setRentalOption}>
                <Radio className="label-font-round" name="rentalRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="rentalRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Has the client ever received subsidized housing from a public housing authority?
              </p>
              <RadioGroup inline value={subsidizedHousingRadio} name="subsidizedHousingRadioOption" onChange={this.setSubsidizedHousingOption}>
                <Radio className="label-font-round" name="subsidizedHousingRadioOption" customInput label="Yes" value="Yes" />
                <Radio className="label-font-round" name="subsidizedHousingRadioOption" customInput label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client owe anyone or any public housing authority past-due rent?
              </p>
              <RadioGroup inline value={pastDueRadio} name="pastDueRadioOption" onChange={this.setPastDueOption}>
                <Radio className="label-font-round" name="pastDueRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="pastDueRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Has the client ever been evicted from rental housing?
              </p>
              <RadioGroup inline value={evictedRentalRadio} name="evictedRentalRadioOption" onChange={this.setEvictedRentalOption}>
                <Radio className="label-font-round" name="evictedRentalRadioOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="evictedRentalRadioOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <Row>
              {
                evictedRentalRadio !== 'Yes' ?
                <div className="disabledHousingHist d-flex">
                  <Col sm="6">
                    <Label className="label-font" htmlFor="evictedDatesField">
                      <em>
                        If yes, please list dates:
                      </em>
                    </Label>
                    <Field
                      type="textarea"
                      id="evictedDatesField"
                      name="evictedDatesFieldOption"
                      className={'straighten-borders form-control form-group textAreaHeightDetails'}
                      onChange={this.setPersonalInformation}
                      value={evictedDatesField}
                      row="3"
                      col="200"
                      maxLength={500}
                      disabled
                    />
                    <label htmlFor="evictedDatesField" style={{ float: 'right' }} className="small text-right mb-0 label-font">500 Character max</label>
                  </Col>
                </div>
                :
                <Col sm="6">
                  <Label className="label-font" htmlFor="evictedDatesField">
                    <em>
                      If yes, please list dates:
                    </em>
                  </Label>
                  <Field
                    type="textarea"
                    id="evictedDatesField"
                    name="evictedDatesFieldOption"
                    className={'straighten-borders form-control form-group textAreaHeightDetails'}
                    onChange={this.setPersonalInformation}
                    value={evictedDatesField}
                    row="3"
                    col="200"
                    maxLength={500}
                  />
                  <p className="small text-right mb-0 label-font">500 Character max</p>
                </Col>
              }
            </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(PersonalInfoHousingHistory);

PersonalInfoHousingHistory.propTypes = {
  navigate: PropTypes.func
};